<template>
  <div class="inner">
    <p id="topLead" class="animation fadeInUp"><span class="lead">ニーズを捉え、<br>時代を先取りする。</span></p>
    <section class="section flex flex-align animation fadeInUp">
      <header class="sectionHd">
        <h2 class="sectionHd-en">NEWS</h2>
        <p class="sectionHd-jp tb-hide"><a href="/news">一覧を見る</a></p>
      </header>
      <div class="sectionBd">
        <ul class="flex">
          <li v-for="(news, index) in newsList" v-bind:key="index" class="newsItem">
            <router-link v-bind:to="{ name: 'NewsDetail', params: { path: news.path } }" class="flex flex-column opacity">
              <p class="newsItem-date">{{ news.formatDate }}</p>
              <p class="newsItem-txt">{{ news.title }}</p>
            </router-link>
          </li>
        </ul>
        <p class="sectionHd-jp tb-show"><a href="/news">一覧を見る</a></p>
      </div>
    </section>
    <section class="section flex flex-align flex-reverse animation pt30" id="service" v-scroll="handleScroll">
      <header class="sectionHd">
        <h2 class="sectionHd-en">SERVICES</h2>
        <p class="sectionHd-jp">サービス</p>
      </header>
      <div class="sectionBd flex flex-column">
        <div class="flex">
          <section class="serviceItem">
            <h3 class="serviceHd"><img src="../assets/img/top/giftissue.svg" class="img-responsive" alt="Giftissue.com"></h3>
            <ul class="serviceTag">
              <li>#ギフト販売C2Cサービス</li>
              <li>#取引高で業界をリード</li>
            </ul>
            <p class="button"><a v-bind:href="giftissueUrl" target="_blank" rel="noopener">詳しくはこちら <i class="fas fa-external-link-alt"></i></a></p>
          </section>
          <section class="serviceItem">
            <h3 class="serviceHd"><img src="../assets/img/top/kinken.svg" class="img-responsive" alt="金券買取EX"></h3>
            <ul class="serviceTag">
              <li>#ギフト買取サービス</li>
              <li>#高値、迅速、安心取り引き</li>
            </ul>
            <p class="button"><a v-bind:href="kinkenExUrl" target="_blank" rel="noopener">詳しくはこちら <i class="fas fa-external-link-alt"></i></a></p>
          </section>
        </div>
      </div>
    </section>

    <section class="section flex flex-align animation pt30" id="vision" v-scroll="handleScroll">
      <header class="sectionHd">
        <h2 class="sectionHd-en">VISION</h2>
        <p class="sectionHd-jp">企業理念</p>
      </header>
      <div class="sectionBd">
        <p class="txtc"><span class="lead">従業員のライフワークを<br>アシストする。</span></p>
      </div>
    </section>

    <section class="section flex flex-align flex-reverse animation pt30" id="about" v-scroll="handleScroll">
      <header class="sectionHd">
        <h2 class="sectionHd-en">ABOUT</h2>
        <p class="sectionHd-jp">会社概要</p>
      </header>
      <div class="sectionBd">
        <table class="table">
          <tr>
            <th>社名</th>
            <td>株式会社DAYNEEDS　(英社名：DAYNEEDS, Inc.)</td>
          </tr>
          <tr>
            <th>代表取締役</th>
            <td>齋藤　翔平</td>
          </tr>
          <tr>
            <th>専務取締役</th>
            <td>玉城　裕子</td>
          </tr>
          <tr>
            <th>取締役</th>
            <td>神谷　貴洋</td>
          </tr>
          <tr>
            <th>取締役</th>
            <td>西田　哲広</td>
          </tr>
          <tr>
            <th>顧問</th>
            <td>矢野　和之</td>
          </tr>
          <tr>
            <th>設立</th>
            <td>2013年5月23日</td>
          </tr>
          <tr>
            <th>所在地</th>
            <td>〒163-0532 <br class="sp-show">東京都新宿区西新宿1-26-2 新宿野村ビル32階</td>
          </tr>
          <tr>
            <th>事業内容</th>
            <td>
              電子ギフト等の売買プラットフォーム事業<br>
              メディア事業、Eコマース事業の企画・運営
            </td>
          </tr>
          <tr>
            <th>古物商許可証</th>
            <td>
              東京都公安委員会　第 305491408223 号<br>
              交付 平成26年9月9日
            </td>
          </tr>
          <tr>
            <th>取引先金融機関</th>
            <td>三菱UFJ銀行</td>
          </tr>
          <tr>
            <th>資本金</th>
            <td>15,000,000円</td>
          </tr>
          <tr>
            <th>取扱高</th>
            <td>
              2016年9月期実績　72億9,300万円<br>
              2017年9月期実績　68億2,300万円<br>
              2018年9月期実績　75億7,000万円<br>
              2019年9月期実績　95億2,700万円
            </td>
          </tr>
        </table>
      </div>
    </section>

    <div class="animation pt30" v-scroll="handleScroll">
      <div class="section flex flex-column flex-end" id="policy">
        <section class="flex flex-align">
          <header class="sectionHd">
            <h2 class="sectionHd-en">POLICY</h2>
            <p class="sectionHd-jp">行動方針</p>
          </header>
          <p class="sectionBd txtc"><span class="lead">繊細に考え大胆に動く<br>国境を越え、需要を追求<br>チームプレーで勝負する。</span></p>
        </section>
      </div>
    </div>

    <section class="section flex flex-align flex-reverse animation pt30" id="history" v-scroll="handleScroll">
      <header class="sectionHd">
        <h2 class="sectionHd-en">HISTORY</h2>
        <p class="sectionHd-jp">沿革</p>
      </header>
      <div class="sectionBd">
        <table class="table">
          <tr>
            <th class="small">2013. 5</th>
            <td>創業者4名でDAYNEEDS合同会社を設立</td>
          </tr>
          <tr>
            <th class="small">2013. 5</th>
            <td>電子ギフトの買取サービス「金券買取EX」を開始</td>
          </tr>
          <tr>
            <th class="small">2014. 2</th>
            <td>電子ギフトのリユースサイト「Giftissue」を開始</td>
          </tr>
          <tr>
            <th class="small">2014. 6</th>
            <td>合同会社から株式会社へと組織変更を行い、株式会社DAYNEEDSとして始動</td>
          </tr>
          <tr>
            <th class="small">2014. 7</th>
            <td>資本金を10,000,000円に増資</td>
          </tr>
          <tr>
            <th class="small">2014. 9</th>
            <td>東京都新宿区（西新宿七丁目）へ本社移転</td>
          </tr>
          <tr>
            <th class="small">2015. 9</th>
            <td>決算期変更</td>
          </tr>
          <tr>
            <th class="small">2017. 7</th>
            <td>資本金を15,000,000円に増資</td>
          </tr>
          <tr>
            <th class="small">2017. 12</th>
            <td>株式会社金券買取EXを設立</td>
          </tr>
          <tr>
            <th class="small">2018. 4</th>
            <td>会社分割による株式会社金券買取EXへの金券買取事業移管</td>
          </tr>
          <tr>
            <th class="small">2018. 6</th>
            <td>東京都新宿区（西新宿一丁目）へ本社移転</td>
          </tr>
        </table>
      </div>
    </section>

    <section class="section flex flex-align animation pt30" id="recruit" v-scroll="handleScroll">
      <header class="sectionHd">
        <h2 class="sectionHd-en">RECRUIT</h2>
        <p class="sectionHd-jp">採用情報</p>
      </header>
      <ul class="sectionBd flex">
        <li class="recruitItem">
          <div class="recruitImg"><img src="../assets/img/top/recruit1.png" class="img-responsive" alt="Green"></div>
          <p class="button"><a v-bind:href="greenUrl" rel="noopener" target="_blank">詳しくはこちら <i class="fas fa-external-link-alt"></i></a></p>
        </li>
        <li class="recruitItem">
          <div class="recruitImg"><img src="../assets/img/top/recruit2.png" class="img-responsive" alt="Wantedly"></div>
          <p class="button"><a v-bind:href="wantedlyUrl" rel="noopener" target="_blank">詳しくはこちら <i class="fas fa-external-link-alt"></i></a></p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import {News} from '../assets/js/news.js'
import isMobile from 'ismobilejs'
export default {
  name: 'Top',
  data () {
    var news = new News()
    return {
      isMobile,
      newsList: news.list.slice(0, 4),
      greenUrl: process.env.VUE_APP_GREENJAPAN,
      wantedlyUrl: process.env.VUE_APP_WANTEDLY,
      giftissueUrl: process.env.VUE_APP_GIFTISSUE,
      kinkenExUrl: process.env.VUE_APP_KINKENEX
    }
  },
  methods: {
    handleScroll: function (evt, el) {
      if (window.scrollY > el.offsetTop - window.innerHeight + 100) {
        el.classList.add('fadeInUp')
      }
    }
  }
}
</script>

<style scoped>
  #topLead{
    width:100%;
    text-align:center;
    margin-top:45px;
  }

  .lead{
    display:inline-block;
    vertical-align:top;
    text-align:left;
    font-size:56px;
    line-height:1.75;
    font-weight:bold;
    white-space:nowrap;
  }

  .section{
    width:100%;
    height:740px;
  }

  .sectionHd{ text-align:center;}

  .sectionHd-en{
    font-family: 'TTNorms';
    font-weight:bold;
    font-size:48px;
    line-height:1.7;
  }

  .sectionHd-jp{
    width:200px;
    margin:5px auto 0;
    line-height:40px;
    color:#fff;
    text-align:center;
    font-size:150%;
    background:#000;
  }

  .sectionHd-jp a{
    display:block;
    width:100%;
    color:#231815;
    line-height:40px;
    background:#F3D22D;
    transition:all 0.2s ease-out;
  }

  .sectionHd-jp a:hover{
    color:#fff;
    background:#231815;
  }

  .sectionBd{
    width:calc(100% - 300px);
    max-width:740px;
  }

  /*------------------------------------------------------------
      NEWS
  ------------------------------------------------------------*/

  .newsItem{ width:calc(50% - 40px);}

  .newsItem:nth-child(n+3){ margin-top:90px;}

  .newsItem-txt{
    color:#000;
    line-height:1.7;
    margin-top:8px;
    font-size:117%;
  }

  /*------------------------------------------------------------
      SERVICE
  ------------------------------------------------------------*/

  .serviceItem{
    width:calc(50% - 20px);
    max-width:320px;
    text-align:center;
  }

  .serviceHd{
    width:100%;
    max-width:320px;
    margin:0 auto 30px;
  }

  .serviceTag{
    display:inline-block;
    vertical-align:middle;
    text-align:left;
  }

  .serviceTag li{
    text-align:left;
    font-size:117%;
    line-height:1.7;
  }

  .serviceTag li + li{ margin-top:4px;}

  .button{
    width:100%;
    max-width:220px;
    height:40px;
    margin:30px auto 0;
  }

  .button a{
    display:block;
    width:100%;
    height:100%;
    line-height:38px;
    text-align:center;
    color:#000;
    font-size:134%;
    border:1px solid #231815;
    box-sizing:border-box;
    border-radius:3px;
    transition:all 0.2s ease-out;
  }

  .button a:hover{
    color:#fff;
    background:#231815;
  }

  /*------------------------------------------------------------
      ABOUT
  ------------------------------------------------------------*/

  .table{
    width:100%;
    font-size:134%;
  }

  .table th{
    vertical-align:top;
    width:170px;
    line-height:1.2;
    text-align:left;
    font-family: 'TTNorms','Noto Sans JP', "游ゴシック", "Yu Gothic", YuGothic, 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', Osaka, 'MS PGothic', arial, helvetica, sans-serif;
  }

  .table .small{ width:80px;}

  .table td{
    vertical-align:top;
    line-height:1.2;
  }

  /*------------------------------------------------------------
      POLICY
  ------------------------------------------------------------*/

  #policy{ transform: translateY(60px);}
  #policy > .flex{ width:100%;}

  /*------------------------------------------------------------
      RECRUIT
  ------------------------------------------------------------*/

  .recruitItem{
    width:50%;
    max-width:338px;
  }

  .recruitImg{
    width:100%;
    max-width:338px;
    margin:0 auto;
  }

  /*------------------------------------------------------------
      MediaQuery
  ------------------------------------------------------------*/

  /* PC */
  @media screen and (max-width: 1180px) and (min-width: 835px){

    #topLead{ margin-top:3.813559322033898vw;}

    .lead{ font-size:4.745762711864407vw;}
    .section{ height:62.71186440677966vw;}

    .sectionHd-en{ font-size:4.067796610169492vw;}

    .sectionHd-jp{
      width:16.94915254237288vw;
      margin-top:0.423728813559322vw;
      line-height:3.389830508474576vw;
      font-size:1.525423728813559vw;
    }

    .sectionHd-jp a{ line-height:3.389830508474576vw;}

    .sectionBd{
      width:calc(100% - 25.42372881355932vw);
      max-width:62.71186440677966vw;
    }

    /* NEWS */

    .newsItem{ width:calc(50% - 3.389830508474576vw);}

    .newsItem:nth-child(n+3){ margin-top:7.627118644067797vw;}

    .newsItem-txt{
      margin-top:0.6779661016949153vw;
      font-size:1.186440677966102vw;
    }

    /* SERVICE */

    .serviceItem{
      width:calc(50% - 1.694915254237288vw);
      max-width:27.11864406779661vw;
    }

    .serviceHd{
      max-width:27.11864406779661vw;
      margin-bottom:2.542372881355932vw;
    }

    .serviceTag li{ font-size:1.186440677966102vw;}
    .serviceTag li + li{ margin-top:0.3389830508474576vw;}

    .button{
      max-width:18.64406779661017vw;
      height:3.389830508474576vw;
      margin-top:2.542372881355932vw;
    }

    .button a{
      line-height:3.220338983050847vw;
      font-size:1.355932203389831vw;
      border-width:0.0847457627118644vw;
      border-radius:0.2542372881355932vw;
    }

    /* ABOUT */

    .table{ font-size:1.355932203389831vw;}

    .table th{ width:14.40677966101695vw;}
    .table .small{ width:6.779661016949153vw;}

    .table tr:not(:first-child) th,
    .table tr:not(:first-child) td{ padding-top:1.694915254237288vw;}

    /* POLICY */

    #policy{ transform: translateY(5.084745762711864vw);}

    /* RECRUIT */

    .recruitItem,
    .recruitImg{ max-width:28.64406779661017vw;}

  }


  /* TABLET */
  @media screen and (max-width: 834px){

    .lead{ font-size:42px;}

    .section{
      padding:60px 0;
      height:auto;
    }

    .sectionHd,
    .sectionBd{ width:100%;}

    .sectionBd{
      max-width:none;
      margin-top:40px;
    }

    .sectionHd-en{ font-size:36px;}

    .sectionHd-jp{
      width:150px;
      line-height:36px;
      font-size:134%;
    }

    .sectionHd-jp a{ line-height:36px;}
    .sectionBd .sectionHd-jp{ margin-top:40px;}

    #topLead{ margin-top:30px;}

    .newsItem,
    .recruitItem{ width:calc(50% - 20px);}
    .newsItem:nth-child(n+3){ margin-top:40px;}

    .serviceTag{ max-width:200px;}
    .serviceTag li{ font-size:109%;}

    .button{ max-width:200px;}
    .button a{ font-size:117%;}

    #policy{ transform:none;}
  }


  @media screen and (min-width: 481px){

    .table tr:not(:first-child) th,
    .table tr:not(:first-child) td{ padding-top:20px;}

  }

  /* SP */
  @media screen and (max-width: 480px){

    .lead{ font-size:7.366666666666667vw;}

    #topLead{ margin-top:10px;}

    .section{ padding:40px 0;}

    .sectionHd-en{ font-size:234%;}
    .sectionBd{ margin-top:20px;}

    .sectionHd-jp{
      width:120px;
      line-height:28px;
      font-size:100%;
    }

    .sectionHd-jp a{ line-height:28px;}

    .sectionBd .sectionHd-jp{ margin-top:20px;}

    .newsItem,
    .recruitItem{ width:100%;}
    .recruitItem:nth-child(n+2),
    .newsItem:nth-child(n+2){ margin-top:16px;}

    .newsItem-txt{
      font-size:109%;
      margin-top:10px;
    }

    .serviceItem{
      width:100%;
      max-width:none;
      padding-top:20px;
    }

    .serviceItem + .serviceItem{ margin-top:20px;}

    .serviceHd{ margin-bottom:15px;}

    .serviceTag li{ font-size:100%;}
    .serviceTag li + li{ margin-top:6px;}

    .button{
      max-width:200px;
      height:30px;
      margin-top:20px;
    }

    .button a{
      font-size:100%;
      line-height:28px;
    }

    .table{
      display:block;
      font-size:109%;
    }

    .table tbody,
    .table thead,
    .table tr,
    .table th,
    .table td{ display:block;}

    .table th{
      line-height:1.5;
      padding-top:20px;
      margin-bottom:4px;
    }

    .recruitImg{ max-width:236px;}
    .recruitImg + .button{ margin-top:15px;}
  }
</style>
